import { jsx as _jsx } from "react/jsx-runtime";
import { brand } from '@iheart/shared';
import { cn } from './cn.js';
/**
 * Renders text in the brand gradient via background-clip. Use for the main
 * page titles and headings shown across the app.
 */
export function GradientText({ as: Tag = 'span', className, children }) {
    return (_jsx(Tag, { className: cn('bg-clip-text font-semibold text-transparent', className), style: { backgroundImage: brand.gradient.primary }, children: children }));
}
//# sourceMappingURL=GradientText.js.map